import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCTA } from "./components/FloatingCTA";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { Wondering } from "./components/sections/Wondering";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { SoundsLikeYou } from "./components/sections/SoundsLikeYou";
import { WhatsInside } from "./components/sections/WhatsInside";
import { Bonuses } from "./components/sections/Bonuses";
import { Offer } from "./components/sections/Offer";
import { NoMoreScratch } from "./components/sections/NoMoreScratch";
import { Guarantee } from "./components/sections/Guarantee";
import { Testimonials } from "./components/sections/Testimonials";
import { Creator } from "./components/sections/Creator";
import { FAQ } from "./components/sections/FAQ";
import { FinalCTA } from "./components/sections/FinalCTA";
import { Footer } from "./components/sections/Footer";
export function App() {
  return <div className="min-h-screen w-full bg-cream pb-[88px] font-sans text-ink" data-id="element-0" data-mp="3ijpc2xoqyt86">
      <MetaPixel data-id="element-1" data-mp="3mk85gw6ag7ch" />
      <main data-id="element-2" data-mp="3mjq3diwy2ywn">
        <Hero data-id="element-3" data-mp="3mj6ibtbzzuee" />
        <Wondering data-id="element-4" data-mp="3rc9co3oln7vn" />
        <BeforeAfter data-id="element-5" data-mp="3rbrcwx2qabiz" />
        <SoundsLikeYou data-id="element-6" data-mp="3rdkie91luppe" />
        <WhatsInside data-id="element-7" data-mp="3rd17vdeab3le" />
        <Bonuses data-id="element-8" data-mp="5yj0slx59ec" />
        <Offer data-id="element-9" data-mp="6hr7hlrojf6" />
        <NoMoreScratch data-id="element-10" data-mp="4wvhonpuufq" />
        <Guarantee data-id="element-11" data-mp="5ggxfcks0yi" />
        <Testimonials data-id="element-12" data-mp="82ohezguggq" />
        <Creator data-id="element-13" data-mp="2zld2xbxu5jcl" />
        <FAQ data-id="element-14" data-mp="2zlv84y2h77wn" />
        <FinalCTA data-id="element-15" data-mp="2zmepodo7rua5" />
      </main>
      <Footer data-id="element-16" data-mp="2zn6b4vo3kbmp" />
      <FloatingCTA data-id="element-17" data-mp="33mouhn09senf" />
      <PurchasePopup data-id="element-18" data-mp="33m5am0r27g6r" />
    </div>;
}